/* eslint-disable @typescript-eslint/no-confusing-void-expression */
import React, {useState, useEffect} from 'react';
import {Card, Col, Container, Dropdown, Form, Row} from 'react-bootstrap';
import Select, {type MultiValue} from 'react-select';
import customStyles from 'Common/customStyles';
import TableContainer from 'Common/TableContainer';
import ApiUtils from 'api/ApiUtils';
import {toast} from 'react-toastify';
import ModalContainer from 'Common/ModalContainer';
import {DOCUMENT_TITLE} from 'Common/constants/layout';
import Swal from 'sweetalert2';
import {useDispatch, useSelector} from 'react-redux';
import {setProductIds} from 'slices/statusChange/reducer';
import {changeStatus} from 'slices/thunk';
import RestaurantForm from './RestaurantFormNew';
import {variables} from 'utils/constant';

// interface Status {
//   id: number;
//   name: string;
//   model: string;
// }
interface VenueItemType {
  data: {
    data: [];
    total: number;
  };
  display_header_count: number;
  display_home_count: number;

  message: string;
}
interface Club {
  id: number;
  name: string;
}

const Venue = (): JSX.Element => {
  document.title = DOCUMENT_TITLE.Restaurant;
  const [modalFlag, setModalFlag] = useState<boolean>(false);
  const [editVenue, setEditCategory] = useState<any>({});
  const [isEditCatergory, setIsEditCategory] = useState(false);
  const [iseAddCategory, setIsAddCategory] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [sortColumn, setSortColumn] = useState('id');
  // console.log('🚀 ~ Venue ~ setSortColumn:', setSortColumn);

  const [search, setSearch] = useState<string>('');
  // const [statusList, setStatusList] = useState<Status[]>([]);
  // console.log('🚀 ~ Venue ~ statusList:', statusList);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [sortDirection, setSortDirection] = useState('desc');
  // console.log('🚀 ~ Venue ~ setSortDirection:', setSortDirection);
  const [categoryList, setCategoryList] = useState<VenueItemType>();
  const defaultPage = 1;
  const [pageSize, setPageSize] = useState(50);
  const [pageValue, setPageValue] = useState(defaultPage);
  const [totalRecords, setTotalRecords] = useState(defaultPage);

  const currentData = Math.ceil(totalRecords / pageSize);
  const [allChecked, setAllChecked] = useState(false);
  // const [selectedCheckboxes, setSelectedCheckboxes] = useState<string[]>([]);
  const [selectedProductIds, setSelectedProductIds] = useState<number[]>([]);
  const [isCheckboxChanged, setIsCheckboxChanged] = useState(false);
  const dispatch = useDispatch<any>();
  const [isStatusChange, setisStatusChange] = useState(false);

  const [Checked, seChecked] = useState(false);
  const [resetSearchFlag, setResetSearchFlag] = useState(false);

  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [modalImageUrl, setModalImageUrl] = useState('');
  const [venueList, setVenueList] = useState([]);
  const [filter, setFilter] = useState<{
    venue: Array<{value: string; label: string}>;
  }>({venue: []});
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const mappedFilter = filter?.venue?.map((venue: any) => venue?.value);

  const {Layout}: any = useSelector(state => state);
  const [isDark, setIsDark] = useState(false);

  const handleSelectVenueChange = (
    selectedOptions: MultiValue<{value: string; label: string}>,
  ): void => {
    setFilter({venue: [...selectedOptions]}); // Convert read-only array to mutable array
  };
  useEffect(() => {
    if (Layout.layoutModeType === 'dark') {
      setIsDark(true);
    } else if (Layout.layoutModeType === 'light') {
      setIsDark(false);
    } else {
      setIsDark(false);
    }
  }, [Layout.layoutModeType]);

  useEffect(() => {
    ApiUtils.getVenueList(`?&type=restaurant_dropDown`)

      .then(async (data: any): Promise<void> => {
        const mappedData = data?.map((data: any) => {
          return {value: data.id, label: data.name};
        });
        setVenueList(mappedData);
      })
      .catch((error: any) => {
        toast.error(error.message);
      });
    // void fetchStatus();
    setisStatusChange(false);
    setAllChecked(false);
  }, []);

  const closeModal = (): void => {
    setIsImageModalOpen(false);
    setModalImageUrl('');
  };
  useEffect(() => {
    ApiUtils.getRestaurantProfileList(
      `?page=${pageValue}&page_size=${pageSize}&sort_column=${sortColumn}&sort_direction=${sortDirection}&search=${search}`,
      mappedFilter,
    )
      .then(async (data: any): Promise<void> => {
        setCategoryList(data as VenueItemType);
        setTotalRecords(data?.total);
      })
      .catch((error: any) => {
        toast.error(error.message);
      });
    // void fetchStatus();
    setisStatusChange(false);
    setAllChecked(false);
  }, [
    pageValue,
    isEditCatergory,
    iseAddCategory,
    pageSize,
    search,
    isStatusChange,
    filter,
  ]);

  // Add a new function to handle normal search
  const handleSearch = (value: string): void => {
    setSearch(value);
    setPageValue(defaultPage);
  };
  const handleDeleteCategory = async (id: any): Promise<void> => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      html: `
      You won't be able to revert this!<br><br>
    `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    });

    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (result.isConfirmed) {
      ApiUtils.deleteRestaurantProfile(id)

        // eslint-disable-next-line unused-imports/no-unused-vars
        .then(async data => {
          await Swal.fire({
            title: 'Deleted',
            text: (data as any).message,
            icon: 'success',
          });
          ApiUtils.getRestaurantProfileList(
            `?page=${pageValue}&page_size=${pageSize}`,
            mappedFilter,
          )
            .then((data: any) => {
              if (data?.current_page > data?.last_page) {
                setPageValue(data?.last_page);
              }
              setCategoryList(data as VenueItemType);
              setTotalRecords(data?.total);
            })
            .catch((error: any) => {
              toast.error(error.message);
            });
        })
        .catch((error: any) => {
          void Swal.fire({
            title: 'Error!',
            text: error?.response?.data?.message,
            icon: 'error',
          });
        });
      setResetSearchFlag(true);
    }
  };

  const handleNextPagination = (pageSize: any): void => {
    if (currentData > 0 && currentData > pageSize) {
      setPageValue(pageSize + 1);
    }
  };
  const handlePrevPagination = (pageSize: any): void => {
    if (pageSize > 1 && currentData >= pageSize) {
      setPageValue(pageSize - 1);
    }
  };

  const toggleCategoryStatus = async (
    // originalPayload: Record<string, any>,
    id: number,
    statusId: number,
  ): Promise<void> => {
    try {
      // Implement logic to toggle category status
      const paylaod = {
        id,
        status: statusId,
      };

      await ApiUtils.updateRestaurantStatus({...paylaod});

      ApiUtils.getRestaurantProfileList(
        `?page=${pageValue}&page_size=${pageSize}`,
        mappedFilter,
      )
        .then((data: any) => {
          if (data?.current_page > data?.last_page) {
            setPageValue(data?.last_page);
          }
          setCategoryList(data as VenueItemType);
          setTotalRecords(data?.total);
        })
        .catch((error: any) => {
          toast.error(error.message);
        });
    } catch (error) {
      console.error('Error toggling category status:', error);
    }
  };

  // const handleSelectAll = (): void => {
  //   if (allChecked) {
  //     setAllChecked(false);
  //   } else {
  //     setAllChecked(true);
  //   }
  // };
  useEffect(() => {
    if (allChecked) {
      const allIds: any = categoryList?.data?.data?.map(
        (item: {id: any}) => item.id,
      ); // Select all by their IDs
      setSelectedProductIds(allIds);
    } else {
      if (!Checked) {
        setSelectedProductIds([]);
      }
    }
  }, [allChecked, categoryList]);

  useEffect(() => {
    dispatch(setProductIds(selectedProductIds));
    if (selectedProductIds.length > 0) {
      setIsCheckboxChanged(true);
    } else {
      setIsCheckboxChanged(false);
    }
    const categorylength: any = categoryList?.data?.data?.length;

    if (selectedProductIds.length === categorylength) {
      setAllChecked(true);
      seChecked(false);
    }
    if (selectedProductIds.length < categorylength) {
      setAllChecked(false);
      seChecked(true);
    }
  }, [selectedProductIds]);

  const productIds = useSelector(
    (state: any) => state.statusChange.setProductids,
  );
  const setproductstatus = async (e: any): Promise<void> => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'Want to change status for selected Venue',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    });
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (result.isConfirmed) {
      dispatch(changeStatus(e.target.value, productIds, 'category'));
      setisStatusChange(true);
    }
  };
  useEffect(() => {
    setAllChecked(false);
    setSelectedProductIds([]);
  }, [isStatusChange]);

  const clubType = [
    {
      id: 1,
      name: 'Beach/Restaurant',
    },
    {
      id: 2,
      name: 'Fine-Dining',
    },
    {
      id: 3,
      name: 'NightClub/Restaurant',
    },
    // {
    //   id: 4,
    //   name: 'Trendy',
    // },
  ];
  const handleImageClick = (videoUrl: string): void => {
    setModalImageUrl(videoUrl);
    setIsImageModalOpen(true);
  };
  const columns = [
    {
      Header: 'Restaurant Logo',
      disableFilters: true,
      disableSortBy: true,
      filterable: true,
      accessor: 'logo', // Assuming 'image' is the property in your data for the image URL
      Cell: ({cell}: any) => {
        return (
          <React.Fragment>
            {(cell.row.original.logo as boolean) ? (
              <img
                src={cell.value}
                width={60}
                height={60}
                alt="Player"
                onClick={() => handleImageClick(cell.value)}
              />
            ) : (
              '-'
            )}
          </React.Fragment>
        );
      },
    },
    {
      Header: 'Restaurant Name',
      disableFilters: true,
      filterable: true,
      accessor: 'restaurant_name',
      Cell: (cellProps: any) => {
        return cellProps.value;
      },
    },
    {
      Header: 'Venue',
      disableFilters: true,
      filterable: true,
      accessor: 'venue_name',
      Cell: (cellProps: any) => {
        return cellProps.value;
      },
    },

    {
      Header: 'Type',
      disableFilters: true,
      filterable: true,
      accessor: 'type',
      Cell: (cellProps: any) => {
        return clubType?.filter((item: any) => item.id === cellProps.value)[0]
          ?.name;
      },
    },

    {
      Header: 'Commission',
      disableFilters: true,
      filterable: true,
      accessor: 'commission',
      Cell: (cellProps: any) => {
        return cellProps.value === 1
          ? 'Yes'
          : cellProps?.value === 2
            ? 'No'
            : '-';
      },
    },
    {
      Header: 'Cuisine',
      disableFilters: true,
      filterable: true,
      accessor: 'cuisine',
      Cell: (cellProps: any) => {
        return <div className="cuisine-cell">{cellProps.value}</div>;
      },
    },
    {
      Header: 'Tag',
      disableFilters: true,
      filterable: true,
      accessor: 'tag',
      Cell: (cellProps: any) => {
        return <div className="tag-cell">{cellProps.value}</div>;
      },
    },
    {
      Header: 'Indoors',
      disableFilters: true,
      filterable: true,
      accessor: 'indoors',
      Cell: (cellProps: any) => {
        return cellProps.value === 1
          ? 'Yes'
          : cellProps?.value === 2
            ? 'No'
            : '-';
      },
    },

    {
      Header: 'Outdoors',
      disableFilters: true,
      filterable: true,
      accessor: 'outdoors',
      Cell: (cellProps: any) => {
        return cellProps.value === 1
          ? 'Yes'
          : cellProps?.value === 2
            ? 'No'
            : '-';
      },
    },

    {
      Header: 'Bar',
      disableFilters: true,
      filterable: true,
      accessor: 'bar',
      Cell: (cellProps: any) => {
        return cellProps.value === 1
          ? 'Yes'
          : cellProps?.value === 2
            ? 'No'
            : '-';
      },
    },

    {
      Header: 'Special Event',
      disableFilters: true,
      filterable: true,
      accessor: 'special_event',
      Cell: (cellProps: any) => {
        return cellProps.value === 1
          ? 'Yes'
          : cellProps?.value === 2
            ? 'No'
            : '-';
      },
    },

    {
      Header: 'Min party size',
      disableFilters: true,
      filterable: true,
      accessor: 'min_party_size',
      Cell: (cellProps: any) => {
        return cellProps.value;
      },
    },
    {
      Header: 'Max party size',
      disableFilters: true,
      filterable: true,
      accessor: 'max_party_size',
      Cell: (cellProps: any) => {
        return cellProps.value;
      },
    },
    {
      Header: 'Price range/person',
      disableFilters: true,
      filterable: true,
      accessor: 'price_range',
      Cell: (cellProps: any) => {
        return cellProps.value;
      },
    },
    {
      Header: 'User Liked',
      disableFilters: true,
      filterable: true,
      accessor: 'user_favorite_restaurant_count',
      Cell: (cellProps: any) => {
        return cellProps.value;
      },
    },
    {
      Header: 'Status',
      disableFilters: true,
      filterable: true,
      accessor: 'status',

      Cell: (cellProps: any) => {
        // console.log('🚀 ~ cellProps:', cellProps.row.original.guest_status);
        const isActive = cellProps.value === variables.EVENT_ACTIVE_STATUS_ID;
        const newStatusId =
          cellProps.value === variables.EVENT_ACTIVE_STATUS_ID
            ? variables.EVENT_INACTIVE_STATUS_ID
            : variables.EVENT_ACTIVE_STATUS_ID;
        const toggleStatus = async (): Promise<void> => {
          await toggleCategoryStatus(
            // cellProps?.cell?.row?.original, // Orignal object record
            cellProps?.cell?.row?.original?.id,
            newStatusId, // Status
          );
        };

        return (
          <div className="form-check form-switch d-flex">
            <Form.Check
              type="checkbox"
              role="switch"
              id="flexSwitchCheckChecked"
              onChange={toggleStatus}
              checked={isActive}
              className="form-switch-md"
            />
            <div>
              <Form.Label htmlFor="flexSwitchCheckChecked">
                {isActive
                  ? variables.CATEGORY_ACTIVE_STATUS
                  : variables.CATEGORY_INACTIVE_STATUS}
              </Form.Label>
            </div>
          </div>
        );
      },
    },

    {
      Header: 'Action',
      disableFilters: true,
      filterable: true,
      accessor: (cellProps: any) => {
        return (
          <Dropdown className="text-start">
            <Dropdown.Toggle className="btn btn-ghost-primary btn-icon btn-sm arrow-none">
              <i className="mdi mdi-dots-horizontal" />
            </Dropdown.Toggle>
            <Dropdown.Menu as="ul" className="dropdown-menu-end">
              <li>
                <Dropdown.Item
                  onClick={() => {
                    setEditCategory(cellProps);
                    modalToggle();
                  }}>
                  <i className="ri-pencil-fill align-bottom me-2 text-muted" />{' '}
                  Edit
                </Dropdown.Item>
              </li>
              <li>
                <Dropdown.Item
                  onClick={async () => {
                    await handleDeleteCategory(cellProps?.id);
                  }}
                  className="remove-list">
                  <i className="ri-delete-bin-fill align-bottom me-2 text-muted" />
                  Delete
                </Dropdown.Item>
              </li>
            </Dropdown.Menu>
          </Dropdown>
        );
      },
    },
  ];

  function modalToggle(): void {
    setModalFlag(!modalFlag);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [clubList, setClubList] = useState<Club[]>([]);
  // useEffect(() => {
  //   const fetchClubList = async (): Promise<void> => {
  //     try {
  //       const response: any = await ApiUtils.getClub('?type=restaurant');
  //       // console.log('🚀 ~ fetchCategoryList ~ response:', response?.data);
  //       setClubList(response?.data);
  //     } catch (err) {
  //       console.error(err);
  //     }
  //   };

  //   void fetchClubList();
  // }, []);
  return (
    <div className="page-content">
      <Container fluid={true}>
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-sm-0">Restaurant</h4>
        </div>
        <div id="couponsList">
          <Row>
            <Col lg={12}>
              <Card>
                <Card.Body className="bg-soft-light border border-dashed border-start-0 border-end-0">
                  <Form>
                    <Row className="g-3 justify-content-between align-items-center">
                      <Col lg={4}>
                        <div
                          aria-labelledby="category-name-label"
                          className="mb-3">
                          <Form.Label
                            id="category-name-label"
                            htmlFor="category-name">
                            Venue
                          </Form.Label>
                          <Select
                            isMulti
                            className="custom-select"
                            id="venue-name"
                            name="venue-name"
                            value={filter.venue}
                            onChange={handleSelectVenueChange}
                            styles={isDark ? customStyles : {}}
                            // styles={isDark ? colourStyles : {}}
                            options={venueList}></Select>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Card>
                <Card.Body>
                  <TableContainer
                    columns={columns ?? []}
                    data={categoryList?.data?.data ?? []}
                    iscustomPageSize={false}
                    handleNextPagination={handleNextPagination}
                    handlePrevPagination={handlePrevPagination}
                    pageValue={pageValue}
                    isBordered={true}
                    customPageSize={pageSize}
                    isGlobalFilter={true}
                    pageSize={pageSize}
                    currentData={currentData}
                    setPageSize={setPageSize}
                    isAddOptions={true}
                    className="custom-header-css"
                    tableClass="table-centered align-middle table-nowrap mb-0"
                    theadClass="text-muted table-light"
                    SearchPlaceholder="Search Restaurant..."
                    buttonText="Add Restaurant"
                    onClick={() => {
                      setEditCategory({});
                      modalToggle();
                    }}
                    // sortColumn={sortColumn}
                    // sortDirection={sortDirection}
                    // handleSortByColumn={handleSortByColumn}
                    onSearch={handleSearch}
                    isChangeStatus={isCheckboxChanged}
                    isCategory={true}
                    statusClickevent={setproductstatus}
                    resetSearchFlag={resetSearchFlag}
                  />
                  <div className="noresult" style={{display: 'none'}}>
                    <div className="text-center">
                      <h5 className="mt-2">Sorry! No Result Found</h5>
                      <p className="text-muted mb-0">
                        We've searched more than 150+ Orders We did not find any
                        orders for you search.
                      </p>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>

        <ModalContainer
          showModal={modalFlag}
          handleClose={modalToggle}
          modalTitle={
            editVenue.id !== undefined ? 'Edit Restaurant' : 'Add Restaurant'
          }
          customClass="club-modal"
          modalBody={
            <>
              <RestaurantForm
                handleClose={modalToggle}
                editData={editVenue}
                setIsEditCategory={setIsEditCategory}
                setIsAddCategory={setIsAddCategory}
                clubs={clubList}
              />
            </>
          }
        />
      </Container>

      <ModalContainer
        showModal={isImageModalOpen}
        handleClose={closeModal}
        modalTitle="Restaurant Logo"
        size="md"
        isTemplate={true}
        modalBody={
          <>
            <img src={modalImageUrl} className="modal-image-preview" />
          </>
        }
      />
    </div>
  );
};

export default Venue;
